<style lang="scss" src="./RevisionSolicitudReclamacion.scss"></style>
<template src="./RevisionSolicitudReclamacion.html"></template>

<script>
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Divider,
  Form,
  FormItem,
  Option,
  Radio,
  RadioGroup,
  Select,
  Upload
} from 'element-ui';
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import {requestReclamacionMixin} from "@/api/partidoPolitico/reclamacionApi";
import {requestRevisionMixin} from "@/api/partidoPolitico/revisionApi";
import {FileUploadMixin} from "@/mixins/FileUpload";
import moment from "moment-timezone";
import AfiliacionDetail from "@/components/Shared/AfiliacionDetail/AfiliacionDetail";

export default {
  name: "RevisionSolicitudReclamacion",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Upload.name]: Upload,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    AfiliacionDetail,
  },
  mixins: [
    requestRevisionMixin,
    requestReclamacionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    RouterMixin,
    FileUploadMixin
  ],
  data() {
    return {
      loading: true,
      errored: false,
      afiliacion: {
        rut: "",
        nombreCompleto: "",
        domicilio: "",
        fechaNacimiento: '',
        email: "",
        telefonoMovil: "",
        telefonoFijo: "",
        estadorevision: '',
      },
      listaReclamacion: [],
      model: {
        id: '',
        motivosrechazo: '',
        estadoreclamacion: '',
        presentareclamacion: null,
        documento: '',
      },
      rules: {
        presentareclamacion: [
          {
            required: true,
            message: 'Debe Selecionar la opción de reclamación',
            trigger: ['blur', 'change']
          }
        ],
        estadoreclamacion: [
          {
            required: true,
            message: 'Debe Selecionar el estado de reclamación',
            trigger: ['blur', 'change']
          }
        ],
        motivosrechazo: [{
          required: true,
          message: 'Debe Ingresar el motivo de rechazo',
          trigger: ['blur', 'change']
        },
          {
            min: 20,
            message: 'Escriba un motivo de rechazo con mínimo 20 caracteres',
            trigger: ['blur', 'change']
          },
          {
            max: 600,
            message: 'Escriba un motivo de rechazo con máximo 400 caracteres',
            trigger: ['blur', 'change']
          }
        ],
      }
    }
  },
  async beforeMount() {
    this.model.id = this.$route.params.id;
    this.getData();
  },
  methods: {
    afiliacionRevisionVer() {
      return new Promise((resolve, reject) => {
        this.getAfiliacionRevisionVer(this.model.id)
          .then((response) => {
            this.$log.debug('getAfiliacionRevisionVer', response.data.statusCode)
            if (response.data.statusCode === 200) {
              const data = JSON.parse(response.data.datos);
              this.$log.debug(data)

              this.afiliacion.rut = data.cedula
              this.afiliacion.nombreCompleto = data.nombrecompleto
              this.afiliacion.fechaNacimiento = moment(data.fechanacimiento, "YYYYMMDD").format('DD-MM-YYYY')
              this.afiliacion.email = data.email
              this.afiliacion.domicilio = data.domicilio
              this.afiliacion.telefonoMovil = data.telefonomovil
              this.afiliacion.telefonoFijo = data.telefonofijo
              this.afiliacion.estadorevision = data.estado_partido
              this.afiliacion.codigoEstado = data.codigoestado
            } else {
              this.errored = true;
              this.showInfo('No hay datos de su persona')
              reject()
            }
            resolve()
          })
          .catch((err) => {
            this.$log.fatal('getAfiliacionRevisionVer', err, err.response, err.request)
            this.showError("Error al cargar la data de Afiliación")
            reject(err)
          });
      })
    },
    reclamacionEstado() {
      return new Promise((resolve, reject) => {
        return this.getReclamacionEstado()
          .then(response => {
            this.$log.debug('getReclamacionEstado', response.data.statusCode)
            if (response.data.statusCode === 200) {
              this.listaReclamacion = JSON.parse(response.data.datos);
            } else {
              this.errored = true;
              this.showInfo('No hay datos de la reclamación')
              reject()
            }
            resolve()
          })
          .catch((err) => {
            this.$log.fatal('getReclamacionEstado', err, err.response, err.request)
            this.showError("Error al cargar la data de reclamación")
            reject(err)
          });
      })
    },
    getData() {
      const afiliacionRevisionVerFn = this.afiliacionRevisionVer()
      const reclamacionEstadoFn = this.reclamacionEstado()

      this.loading = true
      Promise.all([afiliacionRevisionVerFn,
        reclamacionEstadoFn])
        .then(() => {
          this.$log.debug("request completados")
          this.errored = false
        })
        .catch((err) => {
          this.errored = true
          this.$log.fatal('error al ejecutar los request', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    limpiaValores() {
      this.model.estadoreclamacion = ''
      this.model.motivosrechazo = ''
    },
    limpiaMotivoRechazo() {
      this.model.motivosrechazo = ''
    },
    generarData() {
      let data = {}

      data.presenta_reclamacion = this.model.presentareclamacion;
      data.ident = this.model.id;
      data.estado_reclamacion = this.model.estadoreclamacion === '' ? 2 : this.model.estadoreclamacion;
      data.url_archivo_decision = '';
      data.motivo_rechazo_reclamacion = this.model.motivosrechazo;
      data.documento = this.model.documento;

      return data
    },
    enviarRevisionSolicitudReclamacion() {
      this.$log.debug('enviarRevisionSolicitudReclamacion')
      this.$refs.revisionSolicitudReclamacionForm.validate((valid) => {
        this.$log.debug('valid ', valid)
        if (!valid) {
          this.$log.debug('error submit!!')
          return false
        }

        this.$log.debug("enviando...")
        const loading = this.getLoading()

        const data = this.generarData()
        this.$log.debug('enviarRevisionSolicitud', data)

        this.crearReclamacion(data)
          .then((response) => {
            this.$log.debug('crearReclamacion', response.data.statusCode)
            loading.close();

            if (response.data.statusCode === 201) {
              this.showSuccess('La resolución se ha ingresado correctamente');
              this.navigate({name: 'solicitud'})
              return true
            } else {
              this.showError('Ocurrió un error inesperado al enviar la resolución')
              return false
            }
          })
          .catch((err) => {
            this.$log.fatal('crearReclamacion', err, err.response, err.request)
            loading.close();
            this.showError("No se ha podido ingresar la resolución");

            return false
          });

      })
    },
  },
}
</script>
